import {
  OPEN_CHAT,
  CLOSE_CHAT, GET_MESSAGES
} from '../constants/index'

export const openChat = (payload: number) => {
  return {
    type: OPEN_CHAT,
    payload: payload
  }
}

export const closeChat = (payload: number) => {
  return {
    type: CLOSE_CHAT,
    payload: payload
  }
}

export const getMessagesAction = () => {
  return {
    type: GET_MESSAGES,
    payload: false
  }
}
export const getMessagesSocketAction = (payload: any, ) => {
  return (dispatch: any) => {
    // socket.emit('addReminder', payload)
  }
}
